<template>
  <NavbarOne />
  <PageBanner
    pageTitle="باقات الاشتراك"
    subTitle="اختر الباقة المناسبة واستمتع بآلاف القنوات العربية والعالمية، والأفلام والمسلسلات بجودة HD و4K مع اشتراك IPTV مستقر."
    :pageBannerImage="pageBannerImg"
  />
  <PricingPlans />
  <TestOurService />
  <FAQ />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import PricingPlans from "@/components/Pricing/PricingPlans.vue";
import TestOurService from "@/components/Pricing/TestOurService.vue";
import FAQ from "@/components/Pricing/FAQ.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "PricingPage",
  components: {
    NavbarOne,
    PageBanner,
    PricingPlans,
    TestOurService,
    FAQ,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "أسعار اشتراكات IPTV | أفضل الباقات بجودة HD و4K",
      meta: [
        {
          name: "description",
          content:
            "اطلع على أسعار اشتراكات IPTV واختر الباقة التي تناسب احتياجاتك. استمتع بالقنوات العربية والعالمية، الأفلام والمسلسلات بجودة HD و4K مع سيرفرات مستقرة ودعم فني.",
        },
        {
          name: "keywords",
          content:
            "أسعار IPTV, اشتراك IPTV, باقات IPTV, IPTV 4K, IPTV HD, أسعار القنوات, قنوات عربية, أفلام, مسلسلات",
        },
        {
          property: "og:title",
          content: "أسعار اشتراكات IPTV | أفضل الباقات",
        },
        {
          property: "og:description",
          content:
            "تعرف على باقات وأسعار اشتراكات IPTV واختر الاشتراك المناسب لك مع أفضل جودة وثبات.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/pricing",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-4.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>